import { Component, computed, inject } from '@angular/core';
import { BasketService } from '@basket';
import { CatalogueService } from '@catalogue';
import { InterpolatePipe } from '@common';
import { AccordionComponent, IconComponent } from '@components';
import { CoverDetailsService } from '@data-access';
import { provideTranslationDictionaryMapping, TranslatePipe } from '@i18n';
import { singlePlanTable } from '../../constants/single-plan-table.constants';
import { translation } from '../../i18n/translation.constant';
import { SinglePlanService } from '../../services/single-plan/single-plan.service';

@Component({
  selector: 'app-single-plan-table',
  imports: [AccordionComponent, IconComponent, TranslatePipe, InterpolatePipe],
  templateUrl: './single-plan-table.component.html',
  styleUrl: './single-plan-table.component.scss',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class SinglePlanTableComponent {
  private readonly basketService = inject(BasketService);
  private readonly singlePlanService = inject(SinglePlanService);
  private readonly coverDetailsService = inject(CoverDetailsService);
  private readonly catalogueService = inject(CatalogueService);
  readonly singlePlanTable = singlePlanTable;

  readonly getAccordionContent = computed(() =>
    this.singlePlanService
      .selectedApplianceContent()
      .accordion.map((panel, index) => ({
        ...panel,
        title: this.coverDetailsService.getInclusions()[index] ?? panel.title,
      })),
  );

  readonly hasFreeMonths = () =>
    this.basketService.basketItemQuoteHasFreeMonths();

  readonly warrantyInMonths = () =>
    this.catalogueService.steppedFormApplianceWarranty();
}
